module.exports = __webpack_public_path__ + "img/animate3.c0a31074.gif";